import { render, staticRenderFns } from "./Bestseller.html?vue&type=template&id=3c87ecf1&scoped=true&external"
import script from "./Bestseller.js?vue&type=script&lang=js&external"
export * from "./Bestseller.js?vue&type=script&lang=js&external"
import style0 from "./Bestseller.css?vue&type=style&index=0&id=3c87ecf1&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c87ecf1",
  null
  
)

export default component.exports